export const LOGIN_URL="super-admin/login"
export const FORGOT_URL = "super-admin/change-password-to-mail"
export const UPDATE_PASS = "super-admin/temPassToNewPass"
export const  upload_file = "files/uploadFIle"
export const CHANGE_PASS = "super-admin/change-password-via-token"
export const PROFILE_UPDATE = "super-admin/updateProfileData"
export const CHANGE_OLD_PASSWORD= "super-admin/changePasswordByOldPassword"